/**
 * @desc list
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutPlanMasterRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlan/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
